var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"new-official-agency-description"},[_c('div',{staticClass:"new-official-agency-description__inner new-layout-container"},[_c('h2',[_vm._v(_vm._s(_vm.content.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.content.firstParagraph(_vm.eventName)))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.content.secondParagraph))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25010d68","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/OfficialAgencyDescription.vue
// module id = 1090
// module chunks = 0